// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Esther",
  bookSlug: "esther",
  chapter: 12,
  argument: "Mardochai detects the conspiracy of the two eunuchs.",
  verses: [
    { n: 1, text: "And he abode at that time in the king's court with Bagatha and Thara, the king's eunuchs, who were porters of the palace." },
    { n: 2, text: "And when he understood their designs, and had diligently searched into their projects, he learned that they went about to lay violent hands on king Artaxerxes, and he told the king thereof." },
    { n: 3, text: "Then the king had them both examined; and after they had confessed, commanded them to be put to death." },
    { n: 4, text: "But the king made a record of what was done: and Mardochai also committed the memory of the thing to writing." },
    { n: 5, text: "And the king commanded him, to abide in the court of the palace, and gave him presents for the information." },
    { n: 6, text: "But Aman, the son of Amadathi, the Bugite, was in great honour with the king, and sought to hurt Mardochai and his people, because of the two eunuchs of the king who were put to death." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "At that time, is not in Greek. Capellus therefore argues in vain against the Greek author, as if this event took place in the 2d year. (Houbigant) — The expression often occurs in Scripture, without determining the precise time.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "When. Greek, \"for he heard their deliberations.\" — Told, by the mouth of Esther, chap. ii. 21.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Palace, as an officer. — Presents, of small value. (Calmet) — The king had inquired, (Greek, chap. vi. 3.) \"What glory or favour have we done to Mardochai? and the ministers replied: Thou hast done nothing to him,\" to honour him as he deserves.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Bugite, may refer to some town of Macedon, chap. iii. 1. — Honour. Yet he might be still more exalted, after the conspiracy was detected; (Houbigant) as the king little suspected that he was concerned in it. (Haydock) — Death. It is thought that they wished to place Aman, or some Macedonian, on the throne, chap. xvi. 12, 14. (Calmet) — This reason for the malevolence of Aman, might be unknown to Mardochai, chap. xiii. 12. (Houbigant) — The former was either a favourer of traitors, or perhaps of the same conspiracy.", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
